import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

import './Dialog.scss';

export function AlertDialog(props) {
    const {
        message, show, onConfirm, title, success,
    } = props;
    return (
        <SweetAlert
            title={title}
            show={show}
            error={!success}
            onConfirm={onConfirm}
        >
            {message}
        </SweetAlert>
    );
}

AlertDialog.propTypes = {
    message: PropTypes.string,
    show: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string,
    success: PropTypes.bool,
};

AlertDialog.defaultProps = {
    title: '',
    message: '',
    success: false,
};

export function ConfirmDialog(props) {
    const {
        show, onConfirm, onCancel, title, message, confirmTxt, cancelTxt, btnStyle,
    } = props;
    return (
        <SweetAlert
            show={show}
            warning
            showCancel
            confirmBtnText={confirmTxt}
            cancelBtnText={cancelTxt}
            confirmBtnBsStyle={btnStyle}
            cancelBtnBsStyle="default"
            title={title}
            onConfirm={onConfirm}
            onCancel={onCancel}
        >
            {message === '' ? '¿Está seguro?' : message}
        </SweetAlert>
    );
}

ConfirmDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
    confirmTxt: PropTypes.string,
    cancelTxt: PropTypes.string,
    btnStyle: PropTypes.string,

};

ConfirmDialog.defaultProps = {
    title: '',
    message: '',
    confirmTxt: 'Sí, estoy seguro',
    cancelTxt: 'No, Cancelar',
    btnStyle: 'danger',
};

export function ToastAlert({
    id, message, success, onDismiss,
}) {
    useEffect(() => {
        const timer = setTimeout(() => onDismiss(id), 3000);
        return () => clearTimeout(timer);
    }, [id, onDismiss]);

    return (
        <Alert color={success ? 'success' : 'danger'} isOpen toggle={() => onDismiss(id)} className="text-left">
            <i className={`fas ${success ? 'fa-check-circle' : 'fa-exclamation-circle'} toast-alert-icon`} />
            {message}
        </Alert>
    );
}

ToastAlert.propTypes = {
    id: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
    success: PropTypes.bool,
    onDismiss: PropTypes.func.isRequired,
};

ToastAlert.defaultProps = {
    success: false,
};

export function ToastList({ toasts, onDismiss }) {
    if (!toasts.length) return null;
    return (
        <div className="toast-list-wrapper">
            {toasts.map((t) => (
                <ToastAlert
                    key={t.id}
                    id={t.id}
                    message={t.message}
                    success={t.success}
                    onDismiss={onDismiss}
                />
            ))}
        </div>
    );
}

ToastList.propTypes = {
    toasts: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        message: PropTypes.string,
        success: PropTypes.bool,
    })).isRequired,
    onDismiss: PropTypes.func.isRequired,
};
